'use strict';

angular.module('imagetrend.components')
    .directive('hlpRadio', ['Format', function (Format) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                radioLabel: '@?',
                value: '=?',
                index: '=?',

                //required
                isRequired: '=?',
                requiredText: '@?',

                //disabled
                isDisabled: '=?',

                //label
                showLabel: '@?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                pdf: '=?'
            },
            transclude: true,
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/radio/radio.html',
            link: function (scope, elem, attrs, ctrl) {

                //attributes
                if (!attrs.name) { attrs.name = 'radio'; }
                if (!attrs.id) { attrs.id = attrs.name; }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.radioLabel) { attrs.radioLabel = Format.label(attrs.name); } else { if (attrs.radioLabel == 'EMPTY') { attrs.radioLabel = ''; } }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.requiredText) { attrs.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)) }

                if (!attrs.index) { attrs.index = 0 }

                function RadioDirectiveTag() { }
                scope.__tag = new RadioDirectiveTag();

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                }
                //ctrl.$viewChangeListeners.push(function () {
                //    scope.$eval(attrs.ngChange);
                //});

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.submitted = true;
                });
            }
        };
    }])
;